var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex" },
      [
        _c(
          "vs-radio",
          {
            attrs: {
              vsValue: _vm.val,
              disabled: _vm.disabled,
              color: "#A3CA76"
            },
            model: {
              value: _vm.input,
              callback: function($$v) {
                _vm.input = $$v
              },
              expression: "input"
            }
          },
          [_c("strong", [_vm._v(_vm._s(_vm.label))])]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.message
      ? _c("div", { staticStyle: { "margin-left": "24px" } }, [
          _c("p", [_vm._v(_vm._s(_vm.message))])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03f2dad8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f2dad8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseRadioRich.vue
// module id = null
// module chunks = 